import { render, staticRenderFns } from "./CharactersArchetypeDetail.vue?vue&type=template&id=55276e52&lang=pug&"
import script from "./CharactersArchetypeDetail.vue?vue&type=script&lang=ts&"
export * from "./CharactersArchetypeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports